import React, { useEffect, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import DescriptionIcon from '@mui/icons-material/Description';
import FactCheckIcon from '@mui/icons-material/FactCheck';

import PageHeader from '../components/common/PageHeader';
import AnbieterKontenTab from '../components/eingangsbelege/AnbieterKontenTab';
import BelegeTab from '../components/eingangsbelege/BelegeTab';
import MonatsuebersichtTab from '../components/eingangsbelege/MonatsuebersichtTab';
import { usePermissions } from '../hooks/usePermissions';
import * as P from '../constants/permissions';
import eingangsbelegeService, {
  ProviderDefinition,
} from '../services/eingangsbelegeService';

const EingangsbelegePage: React.FC = () => {
  const { hasAnyPermission, hasPermission } = usePermissions();
  const canViewAll = hasAnyPermission(P.EINGANGSBELEGE_VIEW_ALL, P.EINGANGSBELEGE_MANAGE);
  const canManage = hasPermission(P.EINGANGSBELEGE_MANAGE);
  const [tab, setTab] = useState(0);
  const [providers, setProviders] = useState<ProviderDefinition[]>([]);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    eingangsbelegeService.providers().then(setProviders).catch(() => setProviders([]));
  }, []);

  const refresh = () => setRefreshKey((value) => value + 1);

  return (
    <Box>
      <PageHeader
        title="Eingangsbelege"
        subtitle="SaaS-Rechnungen zentral abrufen, bereitstellen und verbuchen"
        breadcrumbs={[{ label: 'Eingangsbelege' }]}
      />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab icon={<AccountBalanceWalletIcon />} iconPosition="start" label="Anbieter-Konten" />
          <Tab icon={<DescriptionIcon />} iconPosition="start" label="Belege" />
          {canViewAll && (
            <Tab icon={<FactCheckIcon />} iconPosition="start" label="Monatsübersicht" />
          )}
        </Tabs>
      </Box>

      {tab === 0 && (
        <AnbieterKontenTab
          providers={providers}
          canManage={canManage}
          refreshKey={refreshKey}
          onChanged={refresh}
        />
      )}
      {tab === 1 && (
        <BelegeTab
          providers={providers}
          canManage={canManage}
          canViewAll={canViewAll}
          refreshKey={refreshKey}
          onChanged={refresh}
        />
      )}
      {canViewAll && tab === 2 && (
        <MonatsuebersichtTab refreshKey={refreshKey} />
      )}
    </Box>
  );
};

export default EingangsbelegePage;
